import { useState, useEffect } from "react";
import { Formik } from "formik";
import { Radio, Switch } from "@material-ui/core";
import { Col, Form, Row } from "react-bootstrap";
import { InvoiceType, InvoiceTypeOptions, ParentOptions, Relationship, TransportationUsageOptions } from "../../../../../../_helpers/Helpers";
import { StudentWizardNav } from "./StudentWizardNav";
import { StudentBasicInfoForm } from "./StudentBasicInfoForm";
import { FamilyMemberForm } from "./FamilyMemberForm";
import { FamilyMemberBasicInfoForm } from "./FamilyMemberBasicInfoForm";
import { FamilyMemberEducationalBackgroundInfoForm } from "./FamilyMemberEducationalBackgroundInfoForm";
import { AddressInfo } from "./AddressInfo";

export function StudentEditForm({  
  familyMembers,
  sections,
  student,
  btnRef,
  getFamilyMembers,
  getSections,
  getFamilyMember,
  saveStudent
}) {
  const [studentValues, setStudentValues] = useState(student);

  useEffect(() => {
    setStudentValues(student);
  }, [student]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={studentValues}
      onSubmit={(values) => {
        const formData = new FormData();
        const newValues = {
          id: values.id,
          term: values.registrationInfo.term,
          preInterviewId: values.preInterviewId,
          registrationNo: values.registrationNo,
          registrationDate: values.registrationDate === "" ? null : values.registrationDate,
          studentNumber: values.studentNumber === "" ? null : values.studentNumber,
          identityCard: {
            tcKimlikNo: values.identityCard.tcKimlikNo,
            name: values.identityCard.name,
            surname: values.identityCard.surname,
            birthDate: values.identityCard.birthDate === "" ? null : values.identityCard.birthDate,
          },
          sex: values.sex,
          theSchoolWhereComeFrom: values.theSchoolWhereComeFrom,
          phone: values.phone,
          email: values.email,
          facebook: values.facebook,
          twitter: values.twitter,
          isActive: values.isActive,          
          father: values.father,
          mother: values.mother,
          other: values.other,
          parent: values.parent,
          registrationInfo: values.registrationInfo,
          invoiceInfo: values.invoiceInfo
        };
        if (newValues.father.educationalBackground.graduationYear === "") newValues.father.educationalBackground.graduationYear = null;
        if (newValues.mother.educationalBackground.graduationYear === "") newValues.father.educationalBackground.graduationYear = null;
        formData.append("fileData", values.photoFile);
        formData.append("fileRemove", document.getElementsByName("student_photo_remove")[0].value);
        formData.append("serializedData", JSON.stringify(newValues));
        saveStudent(formData);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Dönem
            </Form.Label>
            <Col sm={2}>
              <Form.Control
                type="number" 
                min={1}
                value={values.registrationInfo.term}
                id="registrationInfo.term" 
                placeholder="Dönem"
                onChange={e => {
                  handleChange(e);
                  handleChange("registrationInfo.term2")(e);
                }} />
            </Col>
            <Col sm={2}>
              <Form.Control value={values.registrationInfo.term + 1} id="registrationInfo.term2" readOnly />
            </Col>
          </Form.Group>
          <div className="mb-10"></div>

          {/* <!--begin: Wizard --> */}
          <div          
            className="wizard wizard-4"
            id="student_form_wizard"
            data-wizard-state="step-first"
          >
            {/* <!--begin: Form Wizard Nav --> */}
            <StudentWizardNav />
            {/* <!--end: Form Wizard Nav --> */}

            <div className="pt-lg-5">                
              {/* <!--begin: Form Wizard Step 1--> */}
              <div data-wizard-type="step-content" data-wizard-state="current">
                <div className="mb-10"></div>
                <StudentBasicInfoForm
                  sections={sections}
                  student={student}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  values={values}
                  getSections={getSections}
                />
              </div>
              {/* <!--end: Form Wizard Step 1--> */}

              {/* <!--begin: Form Wizard Step 2--> */}
              <div data-wizard-type="step-content">
                <div className="mt-5 col-7">
                  <FamilyMemberForm
                    memberName={"father"}
                    familyMembers={familyMembers}
                    familyMember={Relationship.Father}
                    getFamilyMembers={getFamilyMembers}
                    getFamilyMember={getFamilyMember}
                    setStudentValues={setStudentValues}
                    values={values}
                  />
                </div>

                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  Temel Bilgiler
                </h5>
                <FamilyMemberBasicInfoForm
                  familyMemberName={"father"}
                  familyMember={student.father}
                  handleChange={handleChange}
                  values={values.father}
                />

                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  Eğitim Durumu
                </h5>
                <FamilyMemberEducationalBackgroundInfoForm
                  backgroundName={"father.educationalBackground"}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  values={values.father.educationalBackground}
                />

                <div className="row">
                  <div className="col-6">
                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      İş Adresi
                    </h5>
                    <AddressInfo
                      addressName={"father.workAddress"}
                      handleChange={handleChange}
                      values={values.father.workAddress}
                    />
                  </div>
                  
                  <div className="col-6">
                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      Ev Adresi
                    </h5>
                    <AddressInfo
                      addressName={"father.homeAddress"}
                      handleChange={handleChange}
                      values={values.father.homeAddress}
                    />
                  </div>
                </div>
              </div>
              {/* <!--end: Form Wizard Step 2--> */}

              {/* <!--begin: Form Wizard Step 3--> */}
              <div data-wizard-type="step-content">
                <div className="mt-5 col-7">
                  <FamilyMemberForm
                    memberName={"mother"}
                    familyMembers={familyMembers}
                    familyMember={Relationship.Mother}
                    getFamilyMembers={getFamilyMembers}
                    getFamilyMember={getFamilyMember}
                    setStudentValues={setStudentValues}
                    values={values}
                  />
                </div>

                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  Temel Bilgiler
                </h5>
                <FamilyMemberBasicInfoForm
                  familyMemberName={"mother"}
                  familyMember={student.mother}
                  handleChange={handleChange}
                  values={values.mother}
                />

                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  Eğitim Durumu
                </h5>
                <FamilyMemberEducationalBackgroundInfoForm
                  backgroundName={"mother.educationalBackground"}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  values={values.mother.educationalBackground}
                />

                <div className="row">
                  <div className="col-6">
                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      İş Adresi
                    </h5>
                    <AddressInfo
                      addressName={"mother.workAddress"}
                      handleChange={handleChange}
                      values={values.mother.workAddress}
                    />
                  </div>
                      
                  <div className="col-6">
                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      Ev Adresi
                    </h5>
                    <AddressInfo
                      addressName={"mother.homeAddress"}
                      handleChange={handleChange}
                      values={values.mother.homeAddress}
                    />
                  </div>
                </div>
              </div>
              {/* <!--end: Form Wizard Step 3--> */}       

              {/* <!--begin: Form Wizard Step 4--> */}
              <div data-wizard-type="step-content">
                <h5 className="mb-10 font-weight-bold text-dark">
                  Öğrenci Velisi
                </h5>
                {
                  ParentOptions.map(option => (
                    <span key={option.value}>
                      <Radio
                        value={option.value}
                        checked={option.value === values.parent}
                        onChange={e => setFieldValue("parent", parseInt(e.target.value))}
                      />
                      {option.label}
                    </span>
                  ))
                }
                {
                  values.parent === Relationship.Other &&
                  <>                    
                    <div className="mt-10 col-7">
                      <FamilyMemberForm
                        memberName={"other"}
                        familyMembers={familyMembers}
                        familyMember={Relationship.Other}
                        getFamilyMembers={getFamilyMembers}
                        getFamilyMember={getFamilyMember}
                        setStudentValues={setStudentValues}
                        values={values}
                      />
                        
                      <Form.Group as={Row} controlId={"other.relationship"}>
                        <Form.Label column sm={4}>
                          Yakınlığı
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control type="text" value={values.other.relationship} placeholder="Yakınlığı" onChange={handleChange} />
                        </Col>
                      </Form.Group>
                    </div>
                                        
                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      Temel Bilgiler
                    </h5>
                    <FamilyMemberBasicInfoForm
                      familyMemberName={"other"}
                      familyMember={student.other}
                      handleChange={handleChange}
                      values={values.other}
                    />

                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      Eğitim Durumu
                    </h5>
                    <FamilyMemberEducationalBackgroundInfoForm
                      backgroundName={"other.educationalBackground"}                      
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                      values={values.other.educationalBackground}
                    />

                    <div className="row">
                      <div className="col-6">
                        <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                          İş Adresi
                        </h5>
                        <AddressInfo
                          addressName={"other.workAddress"}
                          handleChange={handleChange}
                          values={values.other.workAddress}
                        />
                      </div>
                          
                      <div className="col-6">
                        <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                          Ev Adresi
                        </h5>
                        <AddressInfo
                          addressName={"other.homeAddress"}
                          handleChange={handleChange}
                          values={values.other.homeAddress}
                        />
                      </div>
                    </div>
                  </>
                }
              </div>
              {/* <!--end: Form Wizard Step 4--> */}

              {/* <!--begin: Form Wizard Step 5--> */}
              <div data-wizard-type="step-content">
                <h5 className="mb-10 font-weight-bold text-dark">
                  Veli Fatura Bilgileri
                </h5>

                <Form.Group as={Row} controlId={"invoiceType"}>
                  <Form.Label column sm={2}>
                    Fatura Türü
                  </Form.Label>
                  <Col sm={10}>
                    {
                      InvoiceTypeOptions.map(option => (
                        <span key={option.value}>
                          <Radio
                            checked={option.value === values.invoiceInfo.invoiceType}
                            onChange={e => setFieldValue("invoiceInfo.invoiceType", option.value)}
                          />
                          {option.label}
                        </span>                      
                      ))
                    }
                  </Col>
                </Form.Group>

                <div className="row">
                  <div className="col-6">
                    {
                      values.invoiceInfo.invoiceType === InvoiceType.Person &&
                      <>
                        <h5 className="mb-10 font-weight-bold text-dark">
                          Şahıs
                        </h5>

                        <Form.Group as={Row} controlId={"invoiceInfo.personOrCompanyName"}>
                          <Form.Label column sm={3}>
                            Şahıs Adı
                          </Form.Label>
                          <Col sm={9}>
                            <Form.Control type="text" value={values.invoiceInfo.personOrCompanyName} placeholder="Şahıs Adı" onChange={handleChange} />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId={"invoiceInfo.personTC"}>
                          <Form.Label column sm={3}>
                            Şahıs TC
                          </Form.Label>
                          <Col sm={9}>
                            <Form.Control type="text" value={values.invoiceInfo.personTC} placeholder="Şahıs TC" onChange={handleChange} />
                          </Col>
                        </Form.Group>
                      </>                      
                    }
                    {
                      values.invoiceInfo.invoiceType === InvoiceType.Company &&
                      <>
                        <h5 className="mb-10 font-weight-bold text-dark">
                          Şirket
                        </h5>

                        <Form.Group as={Row} controlId={"invoiceInfo.personOrCompanyName"}>
                          <Form.Label column sm={3}>
                            Şirket Adı
                          </Form.Label>
                          <Col sm={9}>
                            <Form.Control type="text" value={values.invoiceInfo.personOrCompanyName} placeholder="Şirket Adı" onChange={handleChange} />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId={"invoiceInfo.taxOffice"}>
                          <Form.Label column sm={3}>
                            Vergi Dairesi
                          </Form.Label>
                          <Col sm={9}>
                            <Form.Control type="text" value={values.invoiceInfo.taxOffice} placeholder="Vergi Dairesi" onChange={handleChange} />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId={"invoiceInfo.taxNumber"}>
                          <Form.Label column sm={3}>
                            Vergi Numarası
                          </Form.Label>
                          <Col sm={9}>
                            <Form.Control type="text" value={values.invoiceInfo.taxNumber} placeholder="Vergi Numarası" onChange={handleChange} />
                          </Col>
                        </Form.Group>
                      </>
                    }
                  </div>

                  <div className="col-6">
                    <h5 className="mb-10 font-weight-bold text-dark">
                      Adres
                    </h5>
                    <AddressInfo
                      addressName={"invoiceInfo.address"}
                      handleChange={handleChange}
                      values={values.invoiceInfo.address}
                    />
                  </div>
                </div>

                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  Servis Bilgileri
                </h5>

                <Form.Group as={Row} controlId="transportationUsage">
                  <Form.Label column sm={2}>
                    Servis Kullanım Türü
                  </Form.Label>
                  <Col sm={10}>
                    {
                      TransportationUsageOptions.map(option => (
                        <span key={option.value}>
                          <Radio
                            checked={option.value === values.registrationInfo.transportationUsage}
                            onChange={e => setFieldValue("registrationInfo.transportationUsage", option.value)}
                          />
                          {option.label}
                        </span>
                      ))
                    }
                  </Col>
                </Form.Group>

                <div className="row">
                  <div className="col-4">
                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      Yemekhane
                    </h5>

                    <Form.Group as={Row} controlId="willUseCafeteria">
                      <Form.Label column sm={6}>
                        Kullanacak
                      </Form.Label>
                      <Col sm={6}>
                        <Switch checked={values.registrationInfo.willUseCafeteria} onChange={handleChange("registrationInfo.willUseCafeteria")} />
                      </Col>
                    </Form.Group>
                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      Kıyafet Bilgileri
                    </h5>

                    <div className="row">
                      <div className="col-5">
                        <Form.Group as={Row} controlId="bougthUniform">
                          <Form.Label column sm={6}>
                            Kıyafet Aldı
                          </Form.Label>
                          <Col sm={6}>
                            <Switch 
                              checked={values.registrationInfo.bougthUniform}
                              onChange={e => {
                                handleChange("registrationInfo.bougthUniform")(e)
                                handleChange("registrationInfo.uniformExplanation")("");
                              }}
                            />
                          </Col>
                        </Form.Group>
                      </div>

                      <div className="col-7">
                        <Form.Group as={Row} controlId="registrationInfo.uniformExplanation">
                          <Col sm={12}>
                            <Form.Control
                              type="text"
                              readOnly={values.registrationInfo.bougthUniform ? false : true}
                              value={values.registrationInfo.uniformExplanation} 
                              placeholder="Kıyafet Açıklaması" 
                              onChange={handleChange} />
                          </Col>
                        </Form.Group>
                      </div>
                    </div>
                  </div>

                  <div className="col-6">
                    <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                      Kitap Durumu
                    </h5>

                    <div className="row">
                      <div className="col-5">
                        <Form.Group as={Row} controlId="bougthBook">
                          <Form.Label column sm={6}>
                            Kitap Aldı
                          </Form.Label>
                          <Col sm={6}>
                            <Switch 
                              checked={values.registrationInfo.bougthBook} 
                              onChange={e => {
                                handleChange("registrationInfo.bougthBook")(e);
                                handleChange("registrationInfo.bookExplanation")("");
                              }} 
                            />
                          </Col>
                        </Form.Group>
                      </div>

                      <div className="col-7">
                        <Form.Group as={Row} controlId={"registrationInfo.bookExplanation"}>
                          <Col sm={12}>
                            <Form.Control
                              type="text"
                              readOnly={values.registrationInfo.bougthBook ? false : true}
                              value={values.registrationInfo.bookExplanation} 
                              placeholder="Kitap Açıklaması" 
                              onChange={handleChange} />
                          </Col>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </div>

                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  Öğrenci Açıklama
                </h5>

                <Form.Group as={Row} controlId="registrationInfo.registrationNote">
                  <Col sm={12}>
                    <Form.Control 
                      as="textarea"
                      rows="3"
                      placeholder="Açıklama"
                      value={values.registrationInfo.registrationNote}
                      onChange={handleChange}
                    />
                  </Col>
                </Form.Group>
              </div>
              {/* <!--end: Form Wizard Step 4--> */}
            </div>
          </div>
          
          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}